var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Box, IconButton, InputAdornment, Stack, TextField, useTheme } from '@mui/material';
import { Mic01Icon, Navigation03Icon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { useRef, useState } from 'react';
import { useAppSelector } from '../../../../../application/store/useStore';
import useTranslate from '../../../../../localization/helpers';
import FindMachine from '../../../../components/FindMachine';
import './style.scss';
var MAX_AUDIO_LENGTH = 120;
var ChatInput = function (_a) {
    var sendMessage = _a.sendMessage, disabled = _a.disabled;
    var theme = useTheme();
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField;
    var _c = __read(useState(false), 2), recordingAudio = _c[0], setRecordingAudio = _c[1];
    var mediaStream = useRef(null);
    var mediaRecorder = useRef(null);
    var isCancellingRef = useRef(false);
    var chunks = useRef([]);
    var timerRef = useRef(undefined);
    var _d = __read(useState(0), 2), secondsRecorded = _d[0], setSecondsRecorded = _d[1];
    var _e = __read(useState(false), 2), findMachineModalOpen = _e[0], setFindMachineModalOpen = _e[1];
    var _f = __read(useState(''), 2), inputValue = _f[0], setInputValue = _f[1];
    var chatInputDisabled = disabled || recordingAudio;
    var _g = useAppSelector(function (state) { return state.common; }), chatMachineStatus = _g.chatMachineStatus, chatApiStatus = _g.chatApiStatus;
    var AiMachineStarting = chatMachineStatus === 'starting' || chatApiStatus === 'off';
    var blobToBase64 = function (blob) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onloadend = function () {
                if (reader.result && typeof reader.result === 'string') {
                    resolve(reader.result.split(',')[1]);
                }
            };
            reader.onerror = function () { return reject(reader.error); };
            reader.readAsDataURL(blob);
        });
    };
    var recordAudio = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stream, audioContext, source, destination, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ audio: true, video: false })];
                case 1:
                    stream = _a.sent();
                    mediaStream.current = stream;
                    audioContext = new AudioContext();
                    source = audioContext.createMediaStreamSource(stream);
                    destination = audioContext.createMediaStreamDestination();
                    source.connect(destination);
                    mediaRecorder.current = new MediaRecorder(destination.stream);
                    mediaRecorder.current.ondataavailable = function (e) {
                        if (!isCancellingRef.current && e.data.size > 0)
                            chunks.current.push(e.data);
                    };
                    mediaRecorder.current.onstop = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var recordedBlob, encodedAudio;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setRecordingAudio(false);
                                    if (!!isCancellingRef.current) return [3 /*break*/, 2];
                                    recordedBlob = new Blob(chunks.current);
                                    chunks.current = [];
                                    return [4 /*yield*/, blobToBase64(recordedBlob)];
                                case 1:
                                    encodedAudio = _a.sent();
                                    sendMessage(encodedAudio, 'audio');
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); };
                    mediaRecorder.current.onstart = function () {
                        isCancellingRef.current = false;
                        setRecordingAudio(true);
                        startTimer();
                    };
                    mediaRecorder.current.start();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    enqueueSnackbar(tWithField('validations.accessDenied', 'chat.microphone'), {
                        autoHideDuration: 3000,
                        variant: 'error',
                        anchorOrigin: { horizontal: 'right', vertical: 'top' }
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var stopRecording = function () {
        if (mediaRecorder.current && ['recording', 'paused'].includes(mediaRecorder.current.state))
            mediaRecorder.current.stop();
        if (mediaStream.current)
            mediaStream.current.getTracks().forEach(function (track) { return track.stop(); });
        clearInterval(timerRef.current);
    };
    var cancelRecording = function () {
        isCancellingRef.current = true;
        chunks.current = [];
        if (mediaRecorder.current && ['recording', 'paused'].includes(mediaRecorder.current.state))
            mediaRecorder.current.stop();
        if (mediaStream.current)
            mediaStream.current.getTracks().forEach(function (track) { return track.stop(); });
        clearInterval(timerRef.current);
        setSecondsRecorded(0);
    };
    var startTimer = function () {
        setSecondsRecorded(0);
        timerRef.current = setInterval(function () {
            setSecondsRecorded(function (prev) {
                var _a;
                if (prev + 1 >= MAX_AUDIO_LENGTH) {
                    (_a = mediaRecorder.current) === null || _a === void 0 ? void 0 : _a.pause();
                    return MAX_AUDIO_LENGTH;
                }
                return prev + 1;
            });
        }, 1000);
    };
    var sendQuestion = function () {
        if (inputValue.trim()) {
            sendMessage(inputValue.trim(), 'text');
            setInputValue('');
        }
    };
    return (_jsxs(Box, { px: { md: 2.5, xs: 1 }, pb: { md: 4, xs: 2 }, pt: 2, display: 'block', width: '100%', children: [_jsxs(Stack, { direction: 'row', gap: 0.5, alignItems: 'center', children: [_jsx(TextField, { disabled: chatInputDisabled, variant: 'outlined', placeholder: recordingAudio
                            ? "Recording... ".concat(secondsRecorded, "s of ").concat(MAX_AUDIO_LENGTH, "s")
                            : "".concat(translate('chat.askAnything'), "..."), fullWidth: true, size: 'small', value: inputValue, onChange: function (e) { return setInputValue(e.target.value); }, onKeyDown: function (e) {
                            if (e.key === 'Enter') {
                                sendQuestion();
                            }
                        }, slotProps: {
                            input: {
                                startAdornment: recordingAudio && (_jsx(InputAdornment, { position: 'start', children: _jsx(IconButton, { size: 'Xs', onClick: function () { return cancelRecording(); }, children: _jsx(Icon, { icon: 'mingcute:close-line', color: theme.palette.error.main, width: '18', height: '18' }) }) })),
                                endAdornment: (_jsx(InputAdornment, { position: 'end', children: _jsx(IconButton, { disabled: disabled || AiMachineStarting, size: 'Xs', onClick: function () {
                                            recordingAudio ? stopRecording() : recordAudio();
                                        }, children: recordingAudio ? (_jsx(Icon, { icon: 'eva:checkmark-fill', color: theme.palette.primary.main, width: '18', height: '18' })) : (_jsx(Mic01Icon, { color: '#009983', size: '18px' })) }) }))
                            }
                        } }), !recordingAudio && (_jsx(IconButton, { disabled: chatInputDisabled, size: 'small', onClick: sendQuestion, children: _jsx(Navigation03Icon, { color: theme.palette.primary.main, size: 24 }) }))] }), _jsx(FindMachine, { isOpen: findMachineModalOpen, setIsOpen: setFindMachineModalOpen })] }));
};
export default ChatInput;
